import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import video from './assets/camera.jpg';
import Meta from './Meta';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '500px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function Viseo() {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTariff] = useState({ title: 'Стандартный' }); 

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
      <React.Fragment>
      <Meta
         title="Установка систем видеонаблюдения для дома и бизнеса под ключ — цена от 2000 руб."
         description="Установка и обслуживание систем видеонаблюдения для безопасности вашего объекта. Установим камеры в Подольске, Домодедово, Климовске, Кучино, Северово, Стрелково, Остафьево, Щербинке, Знамя Октября, Старосырово, Борисовке и т.д."
       />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#34495e',
        }}
      >
        Установка видеонаблюдения под ключ в Москве и области — от 2 000 ₽ за камеру
      </h1>
      
      <p style={{ float: 'right', maxWidth: '40%', marginLeft: '20px', marginBottom: '10px' }}>
                 <img src={video} alt="video Illustration" style={{ width: '100%', height: 'auto' }} />
            </p>

      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Мы предоставляем профессиональные услуги по установке систем видеонаблюдения на любых объектах. Обеспечьте безопасность и контроль за территорией, домом или бизнесом с нашими современными решениями.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Области применения:</h2>
      <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
        <li style={{ fontSize: '1.2em', marginBottom: '20px' }}>Частные дома</li>
        <li style={{ fontSize: '1.2em', marginBottom: '20px' }}>Многоквартирные жилые комплексы</li>
        <li style={{ fontSize: '1.2em', marginBottom: '20px' }}>Офисные здания и деловые центры</li>
        <li style={{ fontSize: '1.2em', marginBottom: '20px' }}>Склады и промышленные объекты</li>
      </ul>
      
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>Работаем по всей Москве и Московской области: <strong>Подольск, Домодедово, Видное, Климовск, Щербинка, Коммунарка, в коттеджных поселках и СНТ и т.д.</strong> </p>

      <p style={{ fontSize: '1.2em', marginTop: '30px' }}>
        Свяжитесь с нами для консультации и получения индивидуального решения под ваши потребности.
      </p>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        {/* <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button> */}
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={e => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}
